export default __webpack_public_path__ + "static/media/2000_Atmospheres_LE.a60320b5.jpg";